import { EChannels } from 'core/model/enums';
import type { TSliceReducer } from 'core/store';
import type { IDistributorsState } from './types';

interface IToggleBranchListItemPurchaseLimit {
  branchId: string;
  channelId: EChannels;
  enabled: boolean;
}

interface IToggleBranchListItemCredit {
  branchId: string;
  enabled: boolean;
}

const updateBranchesListQuery: TSliceReducer<IDistributorsState, { query: string }> = (state, action) => {
  state.branchesList.query = action.payload.query;
};

const updateBranchesListPage: TSliceReducer<IDistributorsState, { page: number }> = (state, action) => {
  state.branchesList.pagination.currentPage = action.payload.page;
};

const toggleBranchListItemPurchaseLimit: TSliceReducer<IDistributorsState, IToggleBranchListItemPurchaseLimit> = (
  state,
  action,
) => {
  const { branchId, channelId, enabled } = action.payload;

  const branch = state.branchesList.branches.find(branch => branch.branchId === branchId);

  if (branch) {
    const purchaseLimit = branch.purchaseLimits.find(limit => limit.channelId === channelId);

    if (purchaseLimit) {
      purchaseLimit.enabled = enabled;
    }
  }
};

const toggleBranchListItemCredit: TSliceReducer<IDistributorsState, IToggleBranchListItemCredit> = (state, action) => {
  const { branchId, enabled } = action.payload;

  const branch = state.branchesList.branches.find(branch => branch.branchId === branchId);

  if (branch) {
    branch.credit.enabled = enabled;
  }
};

export const reducers = {
  updateBranchesListQuery,
  updateBranchesListPage,
  toggleBranchListItemPurchaseLimit,
  toggleBranchListItemCredit,
};
